import React, { useCallback, useEffect, useMemo } from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { TableCell, TableRow, TextField } from '@mui/material';
import { validationCurrencyNBU } from '../../../../utils/validation';

const CurrencyItem = ({ item, isEditable, handleEditCur, handleValidField, isAdmin, titles }) => {
  const { id, buyRate, title } = item;
  const onChange = useCallback((key, value) => {
    handleEditCur({ [key]: value, id: item.id });
  }, [handleEditCur, item.id]);

  const isDisabled = useMemo(() => !isEditable || title === 'UAH', [isEditable, title]);

  const validationTitles = useMemo(() => titles.filter((titleItem) => titleItem !== title), [titles, title]);
  const validationSchema = useMemo(() => validationCurrencyNBU(validationTitles), [validationTitles]);
  const validationValues = { title, buyRate };
  const onSubmit = (values) => {
    onChange('title', values.title);
    onChange('buyRate', values.buyRate);
    onChange('sellRate', values.buyRate);
  };

  const formik = useFormik({
    initialValues: validationValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit
  });

  useEffect(() => {
    handleValidField({ id, isValid: formik.isValid });
  }, [formik.isValid, id, handleValidField]);

  return (
    <TableRow>
      <TableCell>{id}</TableCell>
      <TableCell align="left" sx={{ px: 0 }}>
        <TextField
          id="outlined-basic"
          variant="outlined"
          placeholder={`${title}`}
          name="title"
          type="text"
          disabled={isDisabled || !isAdmin}
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleSubmit}
        />
        {formik.touched.title && formik.errors.title && (<p style={{ color: 'red' }}>{formik.errors.title}</p>)}
      </TableCell>
      <TableCell align="left">
        <TextField
          id="outlined-basic"
          variant="outlined"
          placeholder="Курс"
          name="buyRate"
          type="number"
          onWheel={(e) => e.target.blur()}
          disabled={isDisabled}
          value={formik.values.buyRate}
          onChange={formik.handleChange}
          onBlur={formik.handleSubmit}
        />
        {formik.touched.buyRate && formik.errors.buyRate && (<p style={{ color: 'red' }}>{formik.errors.buyRate}</p>)}
      </TableCell>
    </TableRow>
  );
};

CurrencyItem.propTypes = {
  item: PropTypes.object,
  isEditable: PropTypes.bool,
  handleEditCur: PropTypes.func,
  handleValidField: PropTypes.func,
  isAdmin: PropTypes.bool,
  titles: PropTypes.array
};

export default CurrencyItem;
